module.exports = __webpack_public_path__ + "img/Support-skill-414.5170c9e9.png";